export default {
    AgentOnHoldEvent: "Agent On Hold Event'ı",
    AudioVideoWillBeEnabledAfter: "Görüntünüz ve Sesiniz <b></b> saniye sonra aktif olacaktır...",
    EnableAudioVideo: "Görüntü ve Sesi Aç",
}